<template>
  <div class="panel-list">
    <span class="panel-list__name">{{ listGroup.model.name }}</span>
    <div class="panel-list__items-wrap">
      <template v-if="scrollable">
        <virtual-list ref="virtualList"
                      :is-pinned="true"
                      :size="42" :remain="12"
                      :data-source="listGroup.children">
          <panel-item ref="item" v-for="item in listGroup.children"
                      @click.native="selectItem(item, $event)"
                      :is-selected="currentSelectedItem == item"
                      :name="item.model.name"
                      :key="item.model.id"
                      :has-children="item.hasChildren()">
            <span v-html="item.model.name"></span>
          </panel-item>
        </virtual-list>
      </template>
      <panel-item v-else ref="item" v-for="item in listGroup.children"
                  @click.native="selectItem(item, $event)"
                  :is-selected="currentSelectedItem == item"
                  :name="item.model.name"
                  :key="item.model.id"
                  :path="item.model.path"
                  :has-children="item.hasChildren()">
        <span v-html="item.model.name"></span>
      </panel-item>
    </div>
  </div>
</template>

<script>
  import PanelItem from './PanelItem.vue'
  import { ADD_ATTRIBUTE } from '@/appComponents/oldWorkbench/targetDefinition/store/actions'
  import attributeTypes, { isAttribute } from '@/appComponents/workbench/attributePanel/services/attributeType'
  import ScrollPanel from '@/components/common/scrollPanel'
  import VirtualList from '@/components/common/virtualScrollList'
  import { createPopover, popoverTypes } from '@/components/common/popover'
  import { cloneDeep } from 'lodash'

  export default {
    components: {
      PanelItem,
      ScrollPanel,
      VirtualList
    },
    props: {
      scrollable: {
        type: Boolean,
        default: true
      },
      listGroup: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        currentSelectedItem: null,
        currentAttributePopover: null,
        scrollPositionMap: new WeakMap()
      }
    },
    methods: {
      selectItem (item, event) {
        if (isAttribute(item.model)) {
          this.attributeSelectedHandler(item.model, item, event)
        } else {
          // record the index of the selected item for the current listGroup so we can restore
          // the scroll position when navigating back to it
          this.scrollPositionMap.set(this.listGroup, this.$refs.virtualList.getScrollTop())
          this.$emit('item-selected', item)
        }
      },
      attributeSelectedHandler (attribute, panelItem, event) {
        if (attribute.type === attributeTypes.BOOLEAN) {
          this.addAttributeToDefinition(cloneDeep(attribute))
        } else {
          this.currentSelectedItem = panelItem
          this.currentAttributePopover = createPopover({
            attribute,
            direction: 'right',
            parent: event.target,
            type: popoverTypes.ATTRIBUTE
          })
          this.currentAttributePopover.$on('select', this.addAttributeToDefinition)
          this.currentAttributePopover.$on('dismiss', this.deselectCurrentSelectedItem)
        }
      },
      addAttributeToDefinition (attribute) {
        this.$store.dispatch(ADD_ATTRIBUTE, attribute)
      },
      deselectCurrentSelectedItem () {
        this.currentAttributePopover = null
        this.currentSelectedItem = null
      },
      dismissCurrentAttributePopover () {
        this.currentAttributePopover && this.currentAttributePopover.deleteSelf()
      }
    },
    watch: {
      /**
       * Set the list scroll position to 0 when listGroup changes
       */
      listGroup (newValue) {
        this.$nextTick(() => {
          this.$refs.virtualList.scrollTo(this.scrollPositionMap.get(newValue) || 0)
          // delete the scroll position for the list group we are displaying so
          // we don't record it indefinitely.
          this.scrollPositionMap.delete(newValue)
        })
      }
    }
  }
</script>

<style lang="scss">
  .panel-list {
    display: flex;
    flex-direction: column;
    height: 100%;

    &__items-wrap {
      position: relative;
      height: 100%;
    }

    &__items {
      padding: 0;
      margin: 0;
    }

    &__name {
      display: block;
      margin-bottom: rem(5);
      color: color(grays, extra-light);
      font-size: rem(12);
      font-weight: bold;
      text-transform: uppercase;
    }
  }
</style>



// WEBPACK FOOTER //
// List.vue?7e2645ae